import { getTrackBackground } from 'react-range'

type Props = {
  min: number;
  max: number;
  values: number[];
  children: React.ReactNode;
  trackProps: React.HTMLAttributes<HTMLDivElement>;
}

const Track = (props: Props) => {
  const { min, max, values, children, trackProps } = props;
  const isRtl = document.querySelector('html')?.getAttribute('dir') === 'rtl'

  return (
    <div className="rate-slider__track">
      <div
        {...trackProps}
        className="track-line mt-3"
        style={{
          ...trackProps.style,
          background: getTrackBackground({
            values,
            colors: ["#E7E7E7", "#E7E7E7"],
            min,
            max,
            rtl: isRtl,
          })
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default Track
